<template>
  <v-card>
    <v-card-title>
      <h2 class="card-title">{{ $t('base.add_ingredient_type') }}</h2>
    </v-card-title>
    <v-card-content>
      <v-type-select
        v-model="form.name"
        :label="$t('base.type_ingredient_type_name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        :custom-types="[]"
        :default-types="defaultIngredientTypes"
        @select="onSelectType"
        @create-enabled="onCreateEnabled"
      />
    </v-card-content>
    
    <v-card-actions>
      <v-btn
        @click="onCreate"
        :loading="loading"
        :disabled="!canCreate"
      >
        {{ $t('base.create') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'CreateIngredientTypeModal',

  mixins: [formErrorsMixin],

  data: () => ({
    form: {
      name: ''
    },
    errors: {
      name: null
    },
    loading: false,
    selectedType: null,
    isDefaultType: false,
    createEnabled: false
  }),

  computed: {
    ...mapGetters('ingredienttypes', [
      'ingredientTypes',
      'defaultIngredientTypes'
    ]),

    canCreate () {
      return this.form.name && this.createEnabled
    }
  },

  mounted () {
    this.loadDefaultIngredientTypes()
  },

  methods: {
    ...mapActions('ingredienttypes', [
      'createIngredientType',
      'loadDefaultIngredientTypes'
    ]),

    onSelectType ({ type, isDefault }) {
      this.selectedType = type
      this.isDefaultType = isDefault
    },

    onCreateEnabled (enabled) {
      this.createEnabled = enabled
      if (!enabled) {
        this.errors.name = null
      }
    },

    async onCreate () {
      this.loading = true

      this.checkValidData()

      if (this.errors.name === null) {
        const payload = {
          farm: this.$route.params.farm_id,
          name: this.form.name
        }

        const error = await this.createIngredientType(payload)

        if (!error) {
          this.$emit('update')
          this.$emit('close')
        } else {
          this.$toasted.error(this.$t('errors.incorrect_data'))
        }
      }

      this.loading = false
    },

    checkValidData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    }
  }
}
</script>